<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			 <a-button size="small"   icon="search" @click="queryData" :loading="loading" style="margin:0 0.9375rem;">查询</a-button>
			 <a-button  size="small"   icon="file" @click="exportData" :loading="exportLoading" >导出</a-button>
			<a-button  size="small"   icon="file" @click="exportAllData" :loading="exportLoading" style="margin-left:0.9375rem ;">导出全部</a-button>
			 <a-button  size="small"   icon="printer" @click="doPrint" :loading="exportLoading" style="margin:0 0.9375rem;">打印</a-button>
		</div>
		<vxe-table id="fff" align="center" :data="dataList"  border max-height="600"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="PID" :cell-style="cellClassName">
				 <vxe-table-column type="seq" width="60"></vxe-table-column>
				 <vxe-table-column title="水费号" field="PID" ></vxe-table-column>
				 <vxe-table-column title="用户号" field="customerNum"></vxe-table-column>
				 <vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
				 <vxe-table-column title="地址" field="CustomerAddr" ></vxe-table-column>
				  <vxe-table-column title="电话" field="CustomerMobile"></vxe-table-column>
				  <vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
				  <vxe-table-column title="付费方式" field="PrePaySign">
					  <template #default="{ row }">
							{{row.PrePaySign ==1 ?'预付费':'后付费'}}
					  </template>
				  </vxe-table-column>
				  <vxe-table-column title="错误原因" field="failReason"></vxe-table-column>
		</vxe-table>	
	</div>
</template>

<script>
	export default{
		data(){
			return{
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				loading:false,
				exportLoading:false,
			}
		},
		methods:{
			exportAllData(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_UNCHARGE_CUSTOMERS_EXPORT_ALL_URL);
				this.Api.fetchPostFile(url).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download ='立户未扣费记录导出.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			cellClassName({ row, rowIndex, column }){
				let style = {
					'color':'#000',
				}	
				return style;
			},
			doPrint(){
				this.$refs.mTable.print();
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			exportData:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_UNCHARGE_CUSTOMERS_EXPORT_URL);
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = this.theNeighbor.label+'.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			queryData:function(){
				let param = null;
				if(this.theNeighbor == undefined){
					param = {};
				}else{
					param =  {neighborId:this.theNeighbor.key};
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_UNCHARGE_CUSTOMERS_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
		},
		created() {
			this.queryNeighbors();
			this.queryData();
		}
		
	}
</script>

<style>
</style>
